// extracted by mini-css-extract-plugin
export default {"usersRolesBox":"dashboard_usersRolesBox__Fr9JP"};